var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmnipotent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 64,
    height: 64
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53,0h-5c-0.027,0-0.05,0.013-0.077,0.016c-0.071,0.006-0.137,0.021-0.205,0.041c-0.06,0.018-0.116,0.036-0.17,0.064   c-0.056,0.029-0.105,0.065-0.155,0.105c-0.054,0.043-0.104,0.086-0.148,0.139c-0.018,0.021-0.043,0.033-0.059,0.056L36.288,15.775   c-0.495,0.742-0.539,1.737-0.111,2.535c0.357,0.67,0.991,1.069,1.693,1.069l11.045-0.03c0.07,0.063,0.146,0.365,0.005,0.532   l-17.367,20.99c-0.017-0.07-0.02-0.165,0.019-0.282l4.548-13.967c0.248-0.749,0.124-1.598-0.322-2.215   c-0.376-0.521-0.937-0.818-1.537-0.818H21.125c-0.056-0.092-0.102-0.312,0.003-0.479l0.01-0.016L34.844,1.536   c0.015-0.023,0.016-0.05,0.028-0.073c0.032-0.06,0.053-0.122,0.073-0.189c0.019-0.066,0.034-0.129,0.039-0.196   C34.986,1.051,35,1.028,35,1c0-0.036-0.017-0.067-0.021-0.102c-0.007-0.069-0.019-0.135-0.041-0.201   c-0.02-0.061-0.044-0.116-0.075-0.172c-0.03-0.055-0.063-0.105-0.104-0.154c-0.045-0.054-0.094-0.1-0.15-0.143   c-0.027-0.022-0.044-0.052-0.074-0.071c-0.023-0.014-0.049-0.015-0.073-0.028c-0.061-0.033-0.125-0.054-0.193-0.074   c-0.063-0.018-0.123-0.033-0.188-0.038C34.054,0.014,34.029,0,34,0H11C9.897,0,9,0.897,9,2v60c0,1.103,0.897,2,2,2h42   c1.103,0,2-0.897,2-2V2C55,0.897,54.103,0,53,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmnipotent);
export default __webpack_public_path__ + "static/media/omnipotent.4067b507b84a881107e98bd1aebed303.svg";
export { ForwardRef as ReactComponent };